<form [formGroup]="form">
    <mat-form-field>
        <input matInput placeholder="Street" formControlName="street" required>
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="City" formControlName="city" required>
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="State" formControlName="state" required>
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="Zip" formControlName="zip" required>
    </mat-form-field>
</form>
